<template>
    <div class="admission">
        <div class="wrap">
            <div class="top">
                <img src="../../../assets/images/condition.png" alt="">
                <span class="text">入选条件</span>
                <span class="line"></span>
            </div>
            <p class="intro">
                &emsp;&emsp;根据济南市历下区文化产业协会章程第三章条款规定：协会吸收单位会员实行“入会自愿、退会自由”原则。<br>
                1、单位会员：依法成立的文化产业和文化创意及相关产业企事业单位、研究机构、社会团体等，可以单位会员身份申请加入本会。经自愿书面申请，协会批准后，可以成为济南市历下区文化产业协会的单位会员。<br>
                2、个人会员：从事文化产业工作的专家、学者、管理工作者及热心文化产业工作的人士，文化产业、专业领域内有一定的影响力，可以个人身份申请加入本会。经自愿书面申请，协会批准后，可以成为济南市历下区文化产业协会的单位会员。
            </p>
        </div>
        <div class="wrap">
            <div class="top">
                <img src="../../../assets/images/process.png" alt="">
                <span class="text">入会流程</span>
                <span class="line"></span>
            </div>
            <p class="intro">
                1、填写入会申请表，提交入会资料；资料包括：1）营业执照副本复印件；2）荣誉证书复印件；<br>
                2、秘书处会员部将根据企事业单位提供申报资料进行审核；<br>
                3、通过审核后，通知企事业单位按标准交纳会费，颁发会员证书。
            </p>
        </div>
        <div class="wrap">
            <div class="top">
                <img src="../../../assets/images/due.png" alt="">
                <span class="text">会费标准</span>
                <span class="line"></span>
            </div>
            <p class="intro">
                会员单位：600元/年<br>
                理事单位：1000元/年<br>
                常务理事单位：2000元/年<br>
                副会长单位：3000元/年<br>
                会长单位：5000元/年
            </p>
        </div>
        <div class="wrap">
            <div class="top">
                <img src="../../../assets/images/payment.png" alt="">
                <span class="text">交费方式</span>
                <span class="line"></span>
            </div>
            <p class="intro">
                （汇款、支票、现金均可）<br>
                户名：济南市历下区文化产业协会<br>
                开户行：招行洪楼支行<br>
                账号：531903937610702
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Admission',
    data() {
        return {
            
        }
    },
}
</script>

<style scoped>
.admission{
    margin-top: .2rem;
    background: #fff;
    overflow: hidden;
    padding: 0 .3rem .3rem;
}  
.top{
    margin-top: .3rem;
    display: flex;
    align-items: center;
    margin-bottom: .2rem;
}
.top .text{
    color: #D73038;
    margin-left: .2rem;
}
.top .line{
    flex-grow: 1;
    height: .02rem;
    background: #D73038;
    margin-left: .2rem;
}
.intro{
    line-height: 2;
}
</style>